import { DriverTypeActions, DriverTypeActionTypes } from '@app-driver-management/actions/driver-type.action';
import { DriverType } from '@app-driver-management/common/driver-management.constants';

export interface State {
  driverType: string;
}

function getInitialState() {
  return {
    driverType: DriverType.manualAddition,
  };
}

const { driverType } = getInitialState();

export const initialState: State = {
  driverType,
};

export function reducer(state = initialState, action: DriverTypeActions): State {
  switch (action.type) {
    case DriverTypeActionTypes.UpdateDriverType: {
      const { driverType } = action.payload;
      return {
        ...state,
        driverType,
      };
    }

    default:
      return state;
  }
}
